import { i18n } from 'i18n';

export const ROUTE_PATH = '/admin/clients';
export const TITLE = i18n._('Clients');
